import { render } from "./DashboardChartCard.vue?vue&type=template&id=a5e3bac2&scoped=true"
import script from "./DashboardChartCard.vue?vue&type=script&lang=js"
export * from "./DashboardChartCard.vue?vue&type=script&lang=js"

import "./DashboardChartCard.vue?vue&type=style&index=0&id=a5e3bac2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5e3bac2"]])

export default __exports__